/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { object } from 'prop-types';
import './style.scss';

import { ReactComponent as SearchIcon } from 'src/assets/icons/search.svg';
import { ReactComponent as End } from 'src/assets/icons/erase.svg';
import { isValid } from 'src/services/auth';
import InputMask from 'react-input-mask';
import { FiveK } from '@mui/icons-material';

export default function CustomInput({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  DefaultValue,
  Value,
  Position,
  CorFundo,
  CorTexto,
  Disabled,
  Key,
  TabIndex,
}) {
  const [value, setValue] = useState('');

  return (
    <div
      className={`baseInput ${Class} ${Type} ${Size} disabled${Disabled} ${isValid(value) || DefaultValue != '' ? 'filled' : ''}`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {PlaceHolder}
      </span>
      <input
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
        type={Type}
        defaultValue={DefaultValue}
        disabled={Disabled}
        tabIndex={TabIndex}
      />
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

CustomInput.propTypes = {
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  Value: PropTypes.func,
  DefaultValue: PropTypes.string,
  Disabled: PropTypes.bool,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function MaskInput({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  DefaultValue,
  Value,
  Position,
  CorFundo,
  CorTexto,
  Disabled,
  Mask,
  MaskChar,
  Key,
  TabIndex,
}) {
  const [value, setValue] = useState('');

  return (
    <div
      className={`baseInput ${Class} ${Type} ${Size} disabled${Disabled} ${isValid(value) || DefaultValue != '' ? 'filled' : ''}`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {PlaceHolder}
      </span>
      <InputMask
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
        type={Type}
        defaultValue={DefaultValue}
        disabled={Disabled}
        mask={Mask}
        maskChar={MaskChar}
        tabIndex={TabIndex}
      />
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

MaskInput.propTypes = {
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  Value: PropTypes.func,
  DefaultValue: PropTypes.string,
  Disabled: PropTypes.bool,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Mask: PropTypes.string,
  MaskChar: PropTypes.string,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function SelectInput({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  Options,
  Disabled,
  DefaultValue,
  Position,
  CorFundo,
  CorTexto,
  Key,
  TabIndex,
}) {
  function semCasasDecimais(valor) {
    const str = String(valor);
    const [inteiro] = str.split('.');
    return inteiro;
  }

  const [value, setValue] = useState(DefaultValue);
  useEffect(() => {
    setValue(semCasasDecimais(DefaultValue));
  }, [DefaultValue]);

  return (
    <div
      className={`baseInput ${Class} ${Type} ${Size} disabled${Disabled} filled`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
      tabIndex={TabIndex}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {PlaceHolder}
      </span>
      <select
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
        value={value}
      >
        <option value="">Selecione uma opção.</option>
        {Options &&
          Object.keys(Options).length > 0 &&
          Object.entries(Options).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
      </select>
      <button
        onClick={() => {
          setValue('');
          OnChange({ target: { value: ' ' } });
        }}
        style={{
          background: `${Color}`,
        }}
        className="searchBttn"
        disabled={Disabled}
        tabIndex={TabIndex}
      >
        <div>
          <End />
        </div>
      </button>
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

SelectInput.propTypes = {
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  Options: PropTypes.object,
  Disabled: PropTypes.bool,
  DefaultValue: PropTypes.string,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function SelectInput2({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  Options,
  Disabled,
  DefaultValue,
  Position,
  CorFundo,
  CorTexto,
  Filtro,
  Key,
  TabIndex,
}) {
  const [showPopup, setShowPopup] = useState(false);
  const [search, SetSearch] = useState('');
  const [value, setValue] = useState(DefaultValue);
  const [valueName, setValueName] = useState();

  useEffect(() => {
    setValue(DefaultValue);
    SetSearch('');
  }, [DefaultValue]);

  useEffect(() => {
    if (!value || !Array.isArray(Options)) return;

    const found = Options.find((opt) => {
      try {
        const filtroOpt = JSON.parse(opt.filtro);
        if (!Array.isArray(Filtro)) return false;
        if (filtroOpt.length !== Filtro.length) return false;

        const passaFiltro = filtroOpt.every(
          (val, idx) => semCasasDecimais(val) === semCasasDecimais(Filtro[idx])
        );

        return passaFiltro && opt.valor === value;
      } catch {
        return false;
      }
    });

    setValueName(found?.nome ?? '');

    if (!found) {
      setValue('');
      OnChange({ target: { value: ' ' } });
    }
  }, [value, Options, Filtro]);

  const containerRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowPopup(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function semCasasDecimais(valor) {
    const str = String(valor);
    const [inteiro] = str.split('.');
    return inteiro;
  }

  return (
    <div
      ref={containerRef}
      className={`baseInput ${Class} select2 ${Size} disabled${Disabled} filled ${showPopup ? '' : 'hideIt'}`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
      tabIndex={TabIndex}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {PlaceHolder}
      </span>
      <button
        className="inputBody"
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        value={value}
        onClick={() => setShowPopup(true)}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
      >
        {isValid(value) ? valueName : 'Selecione uma opção.'}
      </button>
      <button
        onClick={() => {
          setValue('');
          OnChange({ target: { value: ' ' } });
        }}
        style={{
          background: `${Color}`,
        }}
        className="searchBttn"
        disabled={Disabled}
        tabIndex={TabIndex}
      >
        <div>
          <End />
        </div>
      </button>

      <div
        className={`inputPopup ${showPopup ? '' : 'hideIt'}`}
        style={{
          backgroundColor: `${CorFundo}`,
          color: `${CorTexto}`,
          borderColor: `${Color}`,
        }}
      >
        <input
          placeholder="Pesquisar"
          type="text"
          onChange={(e) => SetSearch(e.target.value)}
        />
        <button className="searchBttn" disabled={true}>
          <div>
            <SearchIcon />
          </div>
        </button>
        <button onClick={() => setShowPopup(false)}>⇦ Retornar</button>
        <button
          onClick={() => {
            OnChange({ target: { value: ' ' } });
            setValue(' ');
            setShowPopup(false);
          }}
        >
          Selecione uma opção.
        </button>
        {Array.isArray(Options) &&
          Options.filter((opt) => {
            try {
              const filtroOpt = JSON.parse(opt.filtro);
              if (!Array.isArray(Filtro)) return false;
              if (filtroOpt.length !== Filtro.length) return false;

              const passaFiltro = filtroOpt.every(
                (val, idx) =>
                  semCasasDecimais(val) === semCasasDecimais(Filtro[idx])
              );

              const passaSearch =
                String(opt.nome)
                  .toLowerCase()
                  .includes(String(search).toLowerCase()) ||
                String(opt.valor)
                  .toLowerCase()
                  .includes(String(search).toLowerCase());

              return passaFiltro && passaSearch;
            } catch {
              return false;
            }
          }).map((opt, index) => (
            <button
              key={index}
              onClick={() => {
                setShowPopup(false);
                OnChange({ target: { value: opt.valor } });
                setValue(opt.valor);
              }}
            >
              {opt.valor} - {opt.nome}
            </button>
          ))}
      </div>
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

SelectInput2.propTypes = {
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  Options: PropTypes.array,
  Disabled: PropTypes.bool,
  DefaultValue: PropTypes.string,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Filtro: PropTypes.array,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function SearchInput({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  Disabled,
  Position,
  CorFundo,
  CorTexto,
  Key,
  TabIndex,
}) {
  const [value, setValue] = useState('');

  return (
    <div
      className={`baseInput ${Class} ${Type} ${Size} disabled${Disabled} ${value != '' ? 'filled' : ''}`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {' '}
        {PlaceHolder}{' '}
      </span>{' '}
      <input
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
        type={Type}
        disabled={Disabled}
        tabIndex={TabIndex}
      />
      <button
        style={{
          background: `${Color}`,
        }}
        className="searchBttn"
        disabled={Disabled}
        tabIndex={TabIndex}
      >
        <div>
          <SearchIcon />
        </div>
      </button>
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

SearchInput.propTypes = {
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  Disabled: PropTypes.bool,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function ConsultaInput({
  PlaceHolder,
  Color,
  Class,
  OnChange,
  Type,
  Size,
  DefaultValue,
  OnPress,
  Disabled,
  Position,
  CorFundo,
  CorTexto,
  Key,
  TabIndex,
}) {
  const [value, setValue] = useState('');

  return (
    <div
      className={`baseInput ${Class} ${Type} disabled${Disabled} ${value != '' || DefaultValue != '' ? 'filled' : ''}`}
      style={{
        borderColor: `${Color}`,
        background: `${Color}`,
      }}
      tabIndex={TabIndex}
    >
      <span style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}>
        {PlaceHolder}
      </span>
      <input
        style={{ backgroundColor: `${CorFundo}`, color: `${CorTexto}` }}
        onChange={(e) => {
          OnChange(e);
          setValue(e.target.value);
        }}
        type={Type}
        defaultValue={DefaultValue}
        disabled={Disabled}
        tabIndex={TabIndex}
      />
      <button
        style={{
          background: `${Color}`,
        }}
        className="searchBttn"
        onClick={OnPress}
        disabled={Disabled}
        tabIndex={TabIndex}
      >
        <div
          style={{
            background: `${Color}`,
          }}
        >
          <SearchIcon />
        </div>
      </button>
      {Key && (
        <label className="key">
          {Key}|{TabIndex}
        </label>
      )}
    </div>
  );
}

ConsultaInput.propTypes = {
  DefaultValue: PropTypes.string,
  PlaceHolder: PropTypes.string,
  Color: PropTypes.string,
  Class: PropTypes.string,
  OnChange: PropTypes.func,
  Type: PropTypes.string,
  Size: PropTypes.string,
  OnPress: PropTypes.func,
  Disabled: PropTypes.bool,
  Position: PropTypes.number,
  CorFundo: PropTypes.string,
  CorTexto: PropTypes.string,
  Key: PropTypes.string,
  TabIndex: PropTypes.number,
};

export function Toogle({ DefaultValue, OnChange }) {
  const [value, setValue] = useState(false);

  return (
    <button
      className={`toogle ${value ? 'active' : 'notActive'}`}
      onClick={() => {
        const newValue = !value;
        setValue(newValue);
        OnChange(newValue);
      }}
    >
      <div className="body" />
      <div className="handle" />
    </button>
  );
}

Toogle.propTypes = {
  DefaultValue: PropTypes.string,
  OnChange: PropTypes.func,
  TabIndex: PropTypes.number,
};
